import { Colors } from './color'

type Props = {
  value: boolean
  onChange: (value: boolean) => void
  disabled?: boolean
}

export const Toggle = ({ value, onChange, disabled }: Props) => {
  const handleClick = () => {
    if (disabled) return
    onChange(!value)
  }

  return (
    <button
      type='button'
      role='switch'
      aria-checked={value}
      aria-disabled={disabled}
      disabled={disabled}
      onClick={handleClick}
      style={{
        width: 44,
        height: 22,
        border: 'none',
        borderRadius: 22,
        padding: 0,
        position: 'relative',
        cursor: disabled ? 'not-allowed' : 'pointer',
        backgroundColor: disabled
          ? Colors['Gray/300']
          : value
          ? Colors['Samansa_Yellow/500']
          : Colors['Gray/900'],
        transition: 'all 0.2s cubic-bezier(0.3, 0.3, 0.3, 1)',
      }}
    >
      <span
        aria-hidden='true'
        style={{
          position: 'absolute',
          top: 2,
          left: value ? 23 : 3,
          width: 18,
          height: 18,
          borderRadius: '50%',
          backgroundColor: value ? Colors['Gray/900'] : '#7B7A79',
          transition: 'all 0.2s cubic-bezier(0.3, 0.3, 0.3, 1)',
        }}
      />
    </button>
  )
}
